/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Pain_Areas_LongInputs */

const en_us2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A marked region excludes the patterns that load it. Nothing is treated; things are avoided.`)
};

const pt_br2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma região marcada exclui os padrões que a carregam. Nada é tratado; coisas são evitadas.`)
};

const es_419_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una zona marcada excluye los patrones que la cargan. No se trata nada; se evitan cosas.`)
};

const pt_pt2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma região marcada exclui os padrões que a sobrecarregam. Nada é tratado; certas coisas são evitadas.`)
};

const fr_fr2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une zone marquée exclut les mouvements qui la sollicitent. On ne soigne rien ; on évite.`)
};

const de_de2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine markierte Region schließt die Bewegungsmuster aus, die sie belasten. Behandelt wird nichts; vermieden wird.`)
};

const it_it2_intake_why_pain_areas_long = /** @type {(inputs: Intake_Why_Pain_Areas_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una zona segnata esclude i movimenti che la caricano. Non si cura nulla; si evita.`)
};

/**
* | output |
* | --- |
* | "A marked region excludes the patterns that load it. Nothing is treated; things are avoided." |
*
* @param {Intake_Why_Pain_Areas_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_pain_areas_long = /** @type {((inputs?: Intake_Why_Pain_Areas_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Pain_Areas_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_pain_areas_long(inputs)
	if (locale === "es-419") return es_419_intake_why_pain_areas_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_pain_areas_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_pain_areas_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_pain_areas_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_pain_areas_long(inputs)
	return en_us2_intake_why_pain_areas_long(inputs)
});
export { intake_why_pain_areas_long as "intake.why.pain_areas.long" }